module.exports = __webpack_public_path__ + "static/media/workingmemory-words-2.deb2be4f.mp3";